<template>
  <div class="footer">
    <el-row type="flex" :gutter="60">
      <el-col :lg="12" :md="12" :sm="24" :xs="24">
        <!-- 付款方式-->
        <div class="footer-title">{{$t('footer.paymentmethod')}}</div>
        <div>
          <img class="footer-icon" :src="`${$g.imgPrefix}/img/footer/image137@2x.webp`">
          <img class="footer-icon" :src="`${$g.imgPrefix}/img/footer/cc-jcb1@2x.webp`">
          <img class="footer-icon" :src="`${$g.imgPrefix}/img/footer/mastercard1@2x.webp`">
          <img class="footer-icon" :src="`${$g.imgPrefix}/img/footer/visa1@2x.webp`">
          <img class="footer-icon" :src="`${$g.imgPrefix}/img/footer/image136@2x.webp`">
          <img class="footer-icon" @click="goPage('home')" style="width:160px" :src="`${$g.imgPrefix}/img/header/logo-header.png`">
        </div>
      </el-col>
      <el-col :lg="12" :md="12" :sm="24" :xs="24" class="footer-r">
        <div class="footer-item">
          <!-- 站点地图-->
          <div class="footer-title">{{$t('footer.map')}}</div>
          <ul>
            <!-- 主屏幕-->
            <li @click.stop="goPage('home')">{{$t('footer.homescreen')}}</li>
            <!-- 联盟计划-->
            <li @click="goPage('friends')">{{$t('map.affiliateprogram')}}</li>
            <!-- 订阅-->
            <li @click="goPage('subscribe')">{{$t('map.subscribe')}}</li>
            <!-- 客户服务中心-->
            <li @click="goPage('aftersales')">{{$t('footer.aftersales')}}</li>
          </ul>
        </div>
        <div class="footer-item">
          <!-- 帮助中心-->
          <div class="footer-title">{{$t('map.helpcenter')}}</div>
          <ul>
            <!-- 使用条款-->
            <li @click="goPage('helpdetail',{id:9})">{{$t('footer.termsofuse')}}</li>
            <!-- 退款政策-->
            <li @click="goPage('helpdetail',{id:10})">{{$t('footer.refundpolicy')}}</li>
            <!-- 隐私政策-->
            <li @click="goPage('helpdetail',{id:11})">{{$t('footer.privacypolicy')}}</li>
          </ul>
        </div>
        <div class="footer-item lang">
          <!-- 语言-->
          <div class="footer-title mb-7">{{$t('footer.language')}}</div>
          <el-button type="primary" class="green-btn lang-btn" @click="toSetLang">
            <img class="earth" :src="`${$g.imgPrefix}/img/header/earth.svg`">
            <span class="lang-btn-text">{{ filterObj($g.languageList,'code',language).name }}</span>
          </el-button>
        </div>
      </el-col>
    </el-row>
    <div class="bottom">
      <div class="mb-2">Copyright &copy; 2024 Guangxi Nanning Yuanchuang Trading Co., Ltd.and ZHONGLING TRADE LIMITED</div>
      <div>E-mail consultation: delecia@alongshare.com</div>
<!--      所有版权、商标、服务标记均属于相应所有者。-->
<!--      <div>{{$t('footer.footer_10')}}</div>-->
<!--&lt;!&ndash;      版权所有 © 2024 GAMESGO LIMITED 保留所有权利（Unit 1804 South Bank Tower, 55 Upper Ground, London, SE1 9EY）&ndash;&gt;-->
<!--      <div>{{$t('footer.footer_11')}}</div>-->
<!--&lt;!&ndash;      附带条约 和隐私政策&ndash;&gt;-->
<!--      <div>{{$t('footer.footer_12')}}</div>-->
    </div>
    <setLang ref="setLang" v-if="showSetLang" @refresh="refreshPage"/>
  </div>
</template>

<script>
import {
  isEmpty,
  filterObj
} from '@/util/util'
import PubSub from "pubsub-js";
import setLang from "./setLang";
export default {
  name: "footerTemp",
  inject: ['reload'],
  components:{
    setLang
  },
  data(){
    return{
      language:'',
      setLangID: null,
      showSetLang:false,
    }
  },
  methods:{
    filterObj,
    toSetLang(){
      this.showSetLang = true;
      this.$nextTick(()=>{
        this.$refs['setLang'].init();
      })
    },
    refreshPage() {
      this.reload();
    },
    goPage(page,params){
      if(!isEmpty(params)){
        this.$router.push({
          name: page,
          query: params
        })
        return
      }

      if(['subscribe','aftersales','friends','home'].includes(page)){
        if(page==='subscribe'){
          PubSub.publish('setTabActive', 'subscribe');
        } else if(page==='aftersales'){
          //客户服务中心 就是售后支持
          PubSub.publish('setTabActive', 'aftersales');
        }else if(page==='friends'){
          //联盟计划
          PubSub.publish('setTabActive', 'friends');
        } else if(page==='home'){
          //主屏幕
          PubSub.publish('setTabActive', 'home');
        }
        this.$emit('scrollTop', 'pcLayout');
        return;
      }


      this.$router.push({
        name:page
      })
    }
  },
  mounted() {
    this.language = localStorage.lang;
    this.$g.languageCode = localStorage.lang;
    this.setLangID = PubSub.subscribe('changeLanguage', (message, activeName) => {
      this.language = activeName;
      this.$g.languageCode = activeName;
    });
  },
  beforeDestroy() {
    PubSub.unsubscribe(this.setLangID);
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/footer.scss";
</style>